import { BusinessInfo, BusinessTimezoneTypes } from '../../src/types';

export const mockBusinessInfo = ({
  dateRegionalSettingsLocale = 'en',
  businessTimezone = 'America/Mexico_City',
  defaultTimezoneToUse = BusinessTimezoneTypes.BUSINESS,
  allowTimezoneSwitch = true,
}: Partial<BusinessInfo> = {}): BusinessInfo => {
  return {
    dateRegionalSettingsLocale,
    businessTimezone,
    defaultTimezoneToUse,
    allowTimezoneSwitch,
  };
};
